import BackButton from "components/atoms/BackButton";
import useTranslate from "hooks/useTranslate";
import classNames from "classnames";
import "./styles.sass";

type TitleBackProps = {
  onHandleClick: () => void;
  text: string;
  className?: string;
};

export const TitleBack = ({
  onHandleClick,
  text,
  className,
}: TitleBackProps) => {
  const t = useTranslate();

  return (
    <div className={classNames("TitleBack", className)}>
      <BackButton handleClick={onHandleClick} />
      <h3 className="TitleBack__title">{t(text)}</h3>
    </div>
  );
};
